import { IGroup, IFilterElement } from "../models/isearch-response";

const CLASSNAME_TO_OPEN_NAVIGATION = "open";
const CLASSNAME_TO_OPEN_SUBMENU_PANEL = "panelOpen";
const CLASSNAME_TO_OPEN_SUBMENU_LIST_ITEM = "subView";

// open and close selectors
const mobileNavMenu: HTMLElement = document.querySelector("#mobileFilter");
const mobileNavButtonOpen: HTMLElement = document.querySelector("#openMobileFilter");
const mobileNavButtonClose: HTMLElement = document.querySelector("#closeMobileFilter");

const filterElement: HTMLElement = document.querySelector(".prototype__sidebar__link.filter__item.ffSearch");
const menuContainer: HTMLElement = document.querySelector(".menuPanelFilter");
const menuContainerSub: HTMLElement = document.querySelector(".menuPanelSub__prototype");
const filterCloseElement: HTMLElement = document.querySelector(".subPanelClose");

 // submenu selectors
 const subMenuTriggerList: NodeListOf<HTMLElement> = document.querySelectorAll(
	".subPanelTrigger"
);
const subMenuCloseList: NodeListOf<HTMLElement> = document.querySelectorAll(
	".subPanelClose"
); 

function openMobileNav(): void {
	mobileNavMenu.classList.toggle(CLASSNAME_TO_OPEN_NAVIGATION);
}

function toggleSubMenu(menuPanel: HTMLElement, listElement: HTMLElement): void {
	menuPanel.classList.toggle(CLASSNAME_TO_OPEN_SUBMENU_PANEL);
	listElement.classList.toggle(CLASSNAME_TO_OPEN_SUBMENU_LIST_ITEM);
}

function subMenuTriggerFunction(): void {
	const currentMenuPanel = this.closest("ul.menuPanelFilter");
	let currentListElement = this.closest("li.menuPanelSub");
	if (currentListElement === null) {
		currentListElement = this.closest("li.menuPanelSub__prototype");
	}
	if (currentListElement && currentMenuPanel) {
		toggleSubMenu(currentMenuPanel, currentListElement);
	}
}

export const MobileFilter = (): void => {
	if (mobileNavButtonOpen) {
		mobileNavButtonOpen.addEventListener("click", openMobileNav);
	}

	if (mobileNavButtonClose) {
		mobileNavButtonClose.addEventListener("click", openMobileNav);
	}
 	if (subMenuTriggerList.length > 0) {
		subMenuTriggerList.forEach(subMenuTrigger => {
			subMenuTrigger.addEventListener("click", subMenuTriggerFunction);
		});
	}

	if (subMenuCloseList.length > 0) {
		subMenuCloseList.forEach(subMenuClose => {
			subMenuClose.addEventListener("click", subMenuTriggerFunction);
		});
	} 
};

export const UpdateMobileFilters = (groups: IGroup[], ev: HTMLElement): void => {
	menuContainer.innerHTML = "";
	groups.forEach(group => {
		const menu = menuContainerSub.cloneNode(true) as HTMLElement;
		const filterCloseElementClone = filterCloseElement.cloneNode(true) as HTMLElement;
		filterCloseElementClone.addEventListener("click", subMenuTriggerFunction);
		menu.querySelector(".subPanelTrigger").addEventListener("click", subMenuTriggerFunction);
		menu.querySelector(".txt").innerHTML = group.name;
		const subPanel = menu.querySelector(".sidebar-mobile__sub.subPanel__prototype");
		subPanel.append(filterCloseElementClone);

		const isBoolField = group.elements.length === 2 && group.elements.filter(x => x.name === "true") ||
			group.selectedElements.length >= 1 && group.selectedElements.filter(x => x.name === "true");

		if (isBoolField.length > 0) {
			UpdateBoolFilter(isBoolField, group, ev, menu, subPanel);
		}
		else {
			UpdateSelectFilter(group.selectedElements, ev, menu, subPanel, group);
			UpdateSelectFilter(group.elements, ev, menu, subPanel, group);
		}
		
		menuContainer.append(menu);
	});
	ResetToRootMenu();
};

function ResetToRootMenu() {
	if (!menuContainer.querySelector(".subView")) {
		menuContainer.classList.remove(CLASSNAME_TO_OPEN_SUBMENU_PANEL);
	}
}

function UpdateBoolFilter(isBoolField: IFilterElement[], group: IGroup, ev: HTMLElement, menu: HTMLElement, subPanel: Element): void {
	const boolFilter = isBoolField[0];
	const element = filterElement.cloneNode(true) as HTMLElement;
	if (boolFilter.selected) {
		element.querySelector(".filter__checkbox").classList.add("checked");
	}
	element.querySelector(".filter__label").innerHTML += group.name;
	element.querySelector(".filter__label").setAttribute("data-value", group.name);
	element.setAttribute("data-url", boolFilter.searchParams);

	const currentClickedElementName = ev.querySelector(".filter__label")?.getAttribute("data-value");
	if (currentClickedElementName === group.name || currentClickedElementName === group.name) {
		menu.classList.add("subView");
	}
	subPanel.append(element);
}

function UpdateSelectFilter(filterElements: IFilterElement[], clickedElement: HTMLElement, menu: HTMLElement,
	subPanel: Element, group: IGroup): void {
	filterElements.forEach(filter => {
		const element = filterElement.cloneNode(true) as HTMLElement;
		const currentClickedElementName = clickedElement.querySelector(".filter__label")?.getAttribute("data-value");
		if (currentClickedElementName === filter.name || currentClickedElementName === group.name) {
			menu.classList.add("subView");
		}
		
		element.querySelector(".filter__label").innerHTML = `${filter.name} ${element.querySelector(".filter__label").innerHTML}`;
		element.querySelector(".filter__label").setAttribute("data-value", filter.name);
		element.querySelector(".filter__matches").innerHTML += `(${filter.recordCount})`;

		if (filter.selected) {
			element.querySelector(".filter__checkbox").classList.add("checked");
		}
		element.setAttribute("data-url", filter.searchParams);

		subPanel.append(element);
	});
}
